<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        工时制度
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <!-- 带薪年假 -->
    <div class="labourParticulars" v-if="fingerprintShow1">
        <h4 class="labourParticulars-title labourParticulars-title-actve" id="title-box-name1">带薪年假</h4>
        <img src="../../assets/imgContent.png" alt="" class="contentImg-box-img">
        <p class="actve" id="title-box-name">注： 在新财年结算年假时间为5月31日。年假不得累计，不得转入下一财年。</p>
    </div>
    <!-- 病假 -->
    <div class="labourParticulars" v-if="fingerprintShow2">
        <h4 class="labourParticulars-title labourParticulars-title-actve" id="calsIdActive">病假</h4>
        <span class="actve" id="firstIdactive">1. 员工申请病假2天，必须出示三甲医院有效诊断证明（上传至假勤申请-附件），如无法提供，烦请申请年假或事假。</span>
        <span class="actve" id="firstIdactive">2. 员工申请病假3天及以上者，必须出示天津医科大学总医院有效诊断证明及收费单据（上传至假勤申请-附件）。</span>
        <span class="actve" id="firstIdactive">3. 若工作期间或上班途中突发疾病，可电话、微信等方式第一时间向直属领导请假，由直属领导发邮件向部门总监申请病假。恢复上班当天，进行请假流程且补交相关证明材料。</span>
    </div>
    <!-- 婚假 -->
    <div class="labourParticulars" v-if="fingerprintShow3">
        <h4 class="labourParticulars-title labourParticulars-title-actve" id="calsIdActive">婚假</h4>
        <span class="actve" id="firstIdactive">1. 在新东方劳动合同期间结婚员工，均可享受3个工作日的带薪婚假（将完整清晰的结婚证书上传至假勤申请-附件）。</span>
        <span class="actve" id="firstIdactive">2. 婚假应在领取结婚证之日起12个月内休完，逾期不补。</span>
    </div>
    <!-- 丧假 -->
    <div class="labourParticulars" v-if="fingerprintShow4">
        <h4 class="labourParticulars-title labourParticulars-title-actve" id="calsIdActive">丧假</h4>
        <span class="actve" id="firstIdactive">1. 员工的直系亲属（指二代以内直系亲属（包括法律拟制的直系亲属），包括父亲、母亲、丈夫、妻子、子、女、养父母、养子女）去世，可被准予3个工作日的假期。</span>
        <span class="actve" id="firstIdactive">2. 婚丧假应在亲属去世后的1个月内休完。需提供死亡证明（上传至假勤申请-附件）。</span>
    </div>
    <!-- 事假 -->
    <div class="labourParticulars" v-if="fingerprintShow6">
        <h4 class="labourParticulars-title labourParticulars-title-actve" id="calsIdActive">事假</h4>
        <span class="actve" id="firstIdactive">1. 员工在工作时间内，因办理私事需要可申请无薪事假。</span>
        <span class="actve" id="firstIdactive">2. 员工申请事假的，应至少提前1天向部门主管提出申请，并在假勤申请中进行事假申请。特殊原因可在事后说明理由补交申请。</span>
        <span class="actve" id="firstIdactive">3. 请假理由不充分或可能妨碍正常工作时，部门主管可不准假或暂缓准假或缩短假期。为保证工作顺利进行，员工应服从安排。</span>
        <span class="actve" id="firstIdactive">4. 事假一次不超过3天，全年事假累计不得超过15天，超过规定的天数必须详细说明理由并由本机构人力资源部出具处理意见并报第一负责人审批，未说明并审批通过的将视为旷工。</span>
    </div>
    <!-- 假勤申请及考勤确认 -->
    <!-- <div class="labourParticulars" v-if="fingerprintShow7">
        <h4 class="labourParticulars-title labourParticulars-title-actve">假勤申请及考勤确认</h4>
        <p class="actve">1. EHR系统申请流程</p>
        <img src="../../assets/2.jpeg" alt="" class="QRcode">
        <p class="actve">2. 云办公APP申请流程</p>
        <img src="../../assets/13.jpeg" alt="" class="QRcode">
    </div> -->
</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow0: false,
            fingerprintShow1: false,
            fingerprintShow2: false,
            fingerprintShow3: false,
            fingerprintShow4: false,
            fingerprintShow6: false,
            fingerprintShow7: false,
        };
    },
    methods: {
        getOnPage1(){
            var code = this.$route.params.code;
            var name = this.$route.params.name;
            if(name == 'er' && code == '1'){
                this.$router.push({name:"IssueManpower"})
            }else {
                this.$router.push({name:"Manpower"})
            }
        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "555"
                }
            })
        },
        fn() {
            var code = this.$route.params.code;
            if (code == 0) {
                this.fingerprintShow0 = true;
            } else if (code == 1) {
                this.fingerprintShow1 = true;
            } else if (code == 2) {
                this.fingerprintShow2 = true;
            } else if (code == 3) {
                this.fingerprintShow3 = true;
            } else if (code == 4) {
                this.fingerprintShow4 = true;
            } else if (code == 6) {
                this.fingerprintShow6 = true;
            } else if (code == 7) {
                this.fingerprintShow7 = true;
            }
        }
    },
    mounted() {
        this.fn();
    }
};
</script>

<style>
.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}
.actve {
    line-height: 30px;
    letter-spacing: 1px;
}
.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 3% 16px 0;
}

.labourParticulars #active{
    margin: 14px 16px 0!important;
}


.labourParticulars span {
    display: block;
    line-height: 35px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars-title-actve {
    font-size: 16px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30% ;
    display: block;
    margin: 30px auto;
}

.contentImg-box-img {
    width: 90%;
    height: 80%;
    display: block;
    margin: 10px auto;
}
.labourParticulars #title-box-name{
    height: 13%;
}
#title-box-name1 {
    height: 3%;
}
#calsIdActive {
    margin-bottom: 20px;
}
#firstIdactive {
    text-indent: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Manpower/manpowerParticulars3.vue